import { articles } from '@/mocks/data';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="w-full py-14 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            影视资讯
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            欲火视频为您带来最新影视动态与深度影评
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {latestArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              coverImage={article.coverImage}
              summary={article.summary}
              category={article.category}
              author={article.author}
              publishDate={article.publishDate}
              readTime={article.readTime}
            />
          ))}
        </div>
      </div>
    </section>
  );
}